<div class="relative" #headerWrapper>
  <lib-header
    [mosaiqueBackgroundImage]="mosaiqueBackgroundImage"
    [phoneNumber]="phoneNumber"
    [bankLogoSrc]="bankLogoSrc"
    [ekiclikLogoSrc]="ekiclikLogoSrc"
    [wissalUniverLogoSrc]="wissalUniverLogoSrc"
    [placeholder]="placeholder"
    [categories]="categories"
    [selectedTab]="selectedTab"
    [tabs]="tabs"
    [quickLinks]="quickLinks"
    [announcement]="announcement"
    (announcementClick)="onAnnouncementClick($event)"
    [theme]="theme"
    [brands]="brands"
    [orderItemsNumber]="(cartCount$ | async) ?? 0"
    [favoritesNumber]="(favoritesNumber$ | async) ?? 0"
    [isConnected]="isConnected"
    [user_name]="user_name"
    [user_email]="user_email"
    [showLanguagesDropdown]="showLanguagesDropdown"
    [lang]="$any(currentLang.value)"
    (languageChange)="currentLang.setValue($event)"
    [labels]="labels"
    [tabulation_labels]="tabulationLabels"
    [autoHandleMyAccountMenu]="false"
    (searchText)="navigateToProductDetails($event)"
    (searchSubmit)="navigateToCatalogueProduct($event)"
    (showLoginModalRequest)="toggleLoginModal(true)"
    (showForgotPasswordModalRequest)="toggleForgotPasswordModal($event)"
    (showSubscriptionModalRequest)="toggleSubscriptionModal()"
    (logoutEmitter)="onLogout()"
    (assistanceClick)="gotoAssistance()"
    (helpClick)="gotoAssistance()"
    (contactUsClick)="gotoContact()"
    (ourMagazines)="gotoNosMagasin()"
    (cartClick)="toggleCart()"
    (favoritesClick)="onMyFavoritesClick()"
    (logoClick)="navigateHome($event)"
    (myAccountIconClicked)="onMyAccountIconClicked()"
    (categoryClick)="navigateToCategory($event)"
    [searchSuggestions]="searchSuggestions"
    (searchInputChange)="onSearchInputChange($event)"
    (brandSelected)="onBrandSelected($event)"
    (tabClick)="onTabClick($event)"
    (categoryHover)="onCategoryHovered($event)"
    (productClick)="onProductClicked($event)"
  ></lib-header>
  <!--my account dropdown menu-->
  @if (showMyAccountDropdownMenu) {
    <div
      class="absolute z-[100]"
      #accountDropdown
      [style.top.px]="myAccountDropdownPosition.top"
      [style.right.px]="myAccountDropdownPosition.right"
      >
      <lib-account-menu
        [labels]="'lib.accountMenu' | translate"
        class="block w-72"
        [bank]="theme"
        [userName]="user_name"
        [userEmail]="user_email"
        [items]="menuItems"
        [logoutLabel]="logoutLabel"
        (itemClick)="onMenuItemClick()"
        (logout)="onAccountMenuLogout()"
      ></lib-account-menu>
    </div>
  }
</div>

<!-- <lib-category-home
*ngIf="router.url === '/home'"
[categories]="categories" [bannerImageUrl]="bannerImageUrl" >
</lib-category-home>-->
@if (isLoginModalVisible) {
  <app-login-dialog
    (login)="handleLoginEvent($event)"
    (register)="toggleSubscriptionModal()"
    (paswrd)="toggleForgotPasswordModal()"
    (close)="toggleLoginModal(false)"
  ></app-login-dialog>
}
<!-- Forgot Password Modals (using individual components) -->
@if (isForgotPasswordModalVisible) {
  <app-forgot-password-dialog
    [emailParam]="forgotPasswordEmail"
    (done)="toggleForgotPasswordModal()"
  ></app-forgot-password-dialog>
}

<!-- Registration Modal -->
@if (isRegistrationModalVisible) {
  <app-registration-dialog
    (login)="toggleLoginModal(true)"
    (onSubscribe)="toggleSubscriptionModal()"
    >
  </app-registration-dialog>
}
